import styled, { css } from 'styled-components';
import { themeColor } from '../../../theme/getters';
import { modalHeading, smallParagraph, modalLink } from '../../../theme/typography';
import { Input as InputBase } from '../input';
import { Button, BUTTON_MODAL_TYPE } from '../button';
import { Checkbox as CheckboxBase } from '../checkbox';

export const Title = styled.h1`
  ${modalHeading};
  margin-top: 8px;
  margin-bottom: 48px;
  color: ${themeColor('white')};
`;

export const Input = styled(InputBase).attrs(() => ({
  containerStyles: css`
    margin-bottom: 16px;
  `,
}))`
  border-radius: 0;
`;

export const SubmitButton = styled(Button).attrs(() => ({
  theme: BUTTON_MODAL_TYPE,
}))`
  box-shadow: none;
  margin-top: 16px;
`;

export const BottomText = styled.span`
  ${smallParagraph};
  display: grid;
  grid-column-gap: 5px;
  grid-template-columns: 1fr auto;

  color: ${themeColor('gray')};

  &:after {
    display: none;
  }
`;

export const LoginLink = styled.a`
  ${modalLink};
  position: initial;
  color: ${themeColor('gray')};

  &:after {
    background: ${themeColor('gray')};
  }
`;

export const Form = styled.form`
  margin-bottom: 32px;
  width: 100%;
`;

export const Description = styled.p`
  ${smallParagraph};
  color: ${themeColor('white')}
  margin-bottom: 32px;
  width: 100%;
  text-align: center;
`;

export const Checkbox = styled(CheckboxBase)`
  a {
    line-height: 22px;
  }
`;

export const CheckboxWrapper = styled.div`
  padding: 16px 0;

  ${Checkbox}:first-of-type {
    margin-bottom: 16px;
  }
`;
